export const DEFAULT_MAPBOX_TOKEN = "pk.eyJ1IjoibGVuYXJkcyIsImEiOiJjbXFhMDVzNzcwMHowMnBwejIydGZlZDNoIn0.mQjwTGoHrM48rHs_e-0SCg";

export const MAPBOX_GL_JS = "https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.js";

export const MAPBOX_GL_CSS = "https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.css";
